import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { Creators as ListaActions } from '../../../store/ducks/lista';
import { Creators as ModalidadeActions } from '../../../store/ducks/modalidade';

import TipoPesquisaEnum from '../../../enums/TipoPesquisaBeneficiarioEnum';
import FormPesquisaBeneficiario from '../FormPesquisaBeneficiario';
import TabelaPesquisaBeneficiario from '../TablePesquisaBeneficiario';

import ModalConsultaStructure from '../../molecules/ModalConsultaStructure';

function ModalPesquisaBeneficiario({ isOpen, onCloseModal }) {
  const dispatch = useDispatch();

  const { listaInativos } = useSelector((state) => state.lista.response);
  const { usuario } = useSelector((state) => state.auth);

  const paginationInitialParams = useMemo(
    () => ({
      pageNumber: 1,
      pageSize: 10,
    }),
    []
  );

  const formInitialParams = useMemo(
    () => ({
      tipoConsulta: TipoPesquisaEnum.returnPropName.ContratanteModalidadeTermo,
      titular: 'Titular',

      modalidade: '',
      termo: '',
      cartao: '',
      codDaUnimed: '',
      nomeBenefTpBeneficiario: '',
      nomeBeneficiarioI: '',
      dataNascimento: '',
    }),
    []
  );

  const [selectedBeneficiario, setSelectedBeneficiario] = useState(null);
  const [formParams, setFormParams] = useState(formInitialParams);
  const [paginationParams, setPaginationParams] = useState(
    paginationInitialParams
  );

  const handlePesquisar = useCallback(() => {
    if (isOpen && formParams !== null) {
      // Executa request sempre que os parametros mudam ou a paginação muda
      const request = {
        ...paginationParams,
        ...formParams,
        idLista: listaInativos?.idLista,
        nmLista: listaInativos?.nmLista,
        codigoContratante: usuario.codigoContratante,
      };

      dispatch(ListaActions.getListaBeneficiarioRequest(request));
    }
  }, [
    dispatch,
    formParams,
    isOpen,
    listaInativos?.idLista,
    listaInativos?.nmLista,
    paginationParams,
    usuario.codigoContratante,
  ]);

  const handleAdicionarBeneficiario = useCallback(() => {
    const request = {
      idLista: listaInativos?.idLista,
      nmLista: listaInativos?.nmLista,
      beneficiario: {
        ...selectedBeneficiario,
      },
      filtro: {
        idLista: listaInativos?.idLista,
        ...formParams,
      },
    };
    dispatch(ListaActions.postSalvarBeneficiarioInativosRequest(request));
  }, [dispatch, formParams, listaInativos, selectedBeneficiario]);

  const handleChangePage = useCallback((paramsPgs) => {
    setPaginationParams({
      ...paramsPgs,
    });
  }, []);

  const handlePageChangeKeyDown = useCallback(
    (e) => {
      if (e.keyCode === 13 && paginationParams.pageNumber !== '')
        setPaginationParams({
          ...paginationParams,
        });
    },
    [paginationParams]
  );

  useEffect(() => {
    if (isOpen === false) {
      setFormParams(formInitialParams);
      setPaginationParams(paginationInitialParams);
      setSelectedBeneficiario(null);
      dispatch(ListaActions.getListaBeneficiarioRenew());
    }
  }, [dispatch, formInitialParams, isOpen, paginationInitialParams]);

  useEffect(() => {
    dispatch(
      ModalidadeActions.getModalidadesRequest({
        codigoContratante: usuario.codigoContratante,
      })
    );
  }, [dispatch, usuario?.codigoContratante]);

  useEffect(() => {
    const pagination = JSON.stringify(paginationParams);
    const initialPagination = JSON.stringify(paginationInitialParams);

    if (pagination !== initialPagination) {
      handlePesquisar();
    }
  }, [isOpen, paginationInitialParams, paginationParams]);

  const desabilitarBtnPesquisar = useMemo(() => {
    const validacaoValues = {
      ContratanteModalidadeTermo:
        !!formParams?.modalidade && !!formParams?.termo,
      ContratanteCodigoUnimedCartao:
        !!formParams?.cartao && !!formParams?.codDaUnimed,
      ContratanteNomeTipoBeneficiario:
        !!formParams?.nomeBenefTpBeneficiario && !!formParams?.titular,
      ContratanteNomeDataNascimento:
        !!formParams?.nomeBeneficiarioI && !!formParams?.dataNascimento,
    };

    return !validacaoValues[formParams.tipoConsulta];
  }, [formParams]);

  return (
    <ModalConsultaStructure
      isOpen={isOpen}
      titleModal={<>consultar beneficiario</>}
      onCloseModal={onCloseModal}
      BodyModal={
        <TabelaPesquisaBeneficiario
          selectedBeneficiario={selectedBeneficiario}
          handleCheckBeneficiario={setSelectedBeneficiario}
          paginationParams={paginationParams}
          handleChangePage={handleChangePage}
          setPaginationParams={setPaginationParams}
          handlePageChangeKeyDown={handlePageChangeKeyDown}
        />
      }
      HeaderModal={
        <FormPesquisaBeneficiario
          formParams={formParams}
          setFormParams={setFormParams}
          handlePesquisar={handlePesquisar}
          desabilitarBtnPesquisar={desabilitarBtnPesquisar}
          resetarPagination={() => setPaginationParams(paginationInitialParams)}
        />
      }
      handleAdicionarModal={handleAdicionarBeneficiario}
      isDisabledBtnAdicionar={!selectedBeneficiario}
    />
  );
}

export default ModalPesquisaBeneficiario;
